import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/responsive.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

createApp(App).use(store).use(ElementPlus, {
    locale: zhCn,
}).use(router).mount('#app')
